import { useQuery } from '@apollo/client';

import { GetLanguageDocument } from '../graphql/get-language.gql-types';

export type UseLanguage = {
  loadingLanguage: boolean;
  language: string | undefined;
};

export function useLanguage(): UseLanguage {
  const { loading: loadingLanguage, data } = useQuery(GetLanguageDocument);

  return {
    loadingLanguage,
    language: data?.viewer?.accountSettings?.language?.value,
  };
}
